import { PortableText } from '@portabletext/react';
import React from 'react';

const textComponents = {
    block: {
        normal: ({ children }) => <div className={"overflow-hidden"}><div className={"reveal-text"}><p className={"text-p font-medium text-black max-w-text mb-5 leading-snug mt-2"}>{children}</p></div></div>,
        h4: ({ children }) => <div className={"overflow-hidden"}><div className={"reveal-text"}><h4 className={"text-mheadline phone:text-headline font-medium text-black uppercase leading-snug mb-5 break-all"}>{children}</h4></div></div>,
        h5: ({ children }) => <div className={"overflow-hidden"}><div className={"reveal-text"}><h5 className={"text-subheadline font-medium text-black uppercase leading-snug"}>{children}</h5></div></div>,
    },
    marks: {
        strong: ({children}) => <strong>{children}</strong>,
        link: ({value, children}) => {
            const target = (value?.href || '').startsWith('http') ? '_blank' : undefined
            return (
                <a href={value?.href} target={target} rel={target === '_blank' && 'noindex nofollow'} className="text-black hover-underline">
                    {children}
                </a>
            )
        },
    },
};

function Text({ value }) {
    return <PortableText value={value} components={textComponents} />;
}

export default Text;
